import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Package, Menu, Home, Info, Images, History as HistoryIcon, LogOut, ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { AnnouncementBanner } from "@/components/AnnouncementBanner";

const CUSTOMER_KEY = "cincstock_customer";

export function CustomerNav({ showBackHome = false, onHistory, rightExtra = null }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const logout = () => {
    localStorage.removeItem(CUSTOMER_KEY);
    window.location.href = "/";
  };
  const goHistory = () => {
    if (onHistory) onHistory();
    else navigate("/?history=1");
  };

  const items = [
    { label: "Home", icon: Home, testid: "menu-home", action: () => navigate("/") },
    { label: "Instructions", icon: Info, testid: "menu-instructions", action: () => navigate("/instructions") },
    { label: "Catalogs", icon: Images, testid: "menu-catalogs", action: () => navigate("/catalogs") },
    { label: "History", icon: HistoryIcon, testid: "menu-history", action: goHistory },
    { label: "Log Out", icon: LogOut, testid: "menu-logout", action: logout },
  ];

  return (
    <>
      <AnnouncementBanner />
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0A0A0A]/80 border-b border-white/10">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-2">
          <Link to="/" className="flex items-center gap-2.5 min-w-0" data-testid="nav-logo-link">
            <div className="h-8 w-8 border border-white/20 flex items-center justify-center shrink-0">
              <Package className="h-4 w-4 text-white" />
            </div>
            <span className="font-display font-black text-lg sm:text-xl tracking-tighter text-white truncate">
              CiNCStock<span className="text-white/40">.in</span>
            </span>
          </Link>

          <div className="flex items-center gap-2">
            {showBackHome && (
              <>
                <Button
                  onClick={() => navigate(-1)}
                  variant="outline"
                  data-testid="nav-go-back"
                  className="rounded-none h-9 px-2.5 sm:px-3 border-white/20 bg-transparent text-white hover:bg-white hover:text-black text-xs uppercase tracking-wider transition-colors"
                >
                  <ChevronLeft className="h-4 w-4 mr-1" />Back
                </Button>
                <Button
                  onClick={() => navigate("/")}
                  variant="outline"
                  data-testid="nav-home-btn"
                  className="rounded-none h-9 px-2.5 sm:px-3 border-white/20 bg-transparent text-white hover:bg-white hover:text-black text-xs uppercase tracking-wider transition-colors"
                >
                  <Home className="h-4 w-4 mr-1" />Home
                </Button>
              </>
            )}
            {rightExtra}
            <Button
              onClick={() => navigate("/catalogs")}
              data-testid="catalogs-quick-btn"
              className="rounded-none h-9 px-2.5 sm:px-3 bg-white text-black hover:bg-white/90 text-xs uppercase tracking-wider font-semibold transition-colors"
              aria-label="Catalogs"
            >
              <Images className="h-4 w-4 sm:mr-1.5" /><span className="hidden sm:inline">Catalogs</span>
            </Button>
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <Button
                  data-testid="hamburger-menu"
                  variant="outline"
                  className="rounded-none h-9 w-9 p-0 border-white/20 bg-transparent text-white hover:bg-white hover:text-black transition-colors"
                >
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="bg-[#0A0A0A] border-l border-white/10 text-white w-72 p-0">
                <SheetTitle className="sr-only">Menu</SheetTitle>
                <div className="px-5 py-5 border-b border-white/10">
                  <span className="font-display font-black text-xl tracking-tighter text-white">CiNCStock<span className="text-white/40">.in</span></span>
                </div>
                <nav className="flex flex-col p-2" data-testid="mobile-menu">
                  {items.map((it) => (
                    <button
                      key={it.label}
                      data-testid={it.testid}
                      onClick={() => { setOpen(false); it.action(); }}
                      className="flex items-center gap-3 px-4 py-4 text-sm uppercase tracking-wider text-white/80 hover:bg-white hover:text-black border-b border-white/5 transition-colors text-left"
                    >
                      <it.icon className="h-4 w-4" /> {it.label}
                    </button>
                  ))}
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </header>
    </>
  );
}
